module.exports = __webpack_public_path__ + "static/media/fly0187.025883e9.webp";